/*
 * @title App
 * @description Application entry point
 */
// Jquery
import $ from "jquery";

window.jQuery = $;
window.$ = $;
jQuery = $;

// Modules
import navbar from "../modules/navbar/navbar";

// Components
import spinner from "./components/spinner";

import Flickity from "flickity";
import "flickity/css/flickity.css";
require("flickity-fade");

import {gsap} from "gsap";
import {ScrollTrigger} from "gsap/ScrollTrigger";
gsap.registerPlugin(ScrollTrigger);

// Lazyload image
import LazyLoad from "vanilla-lazyload";

// exist element
$.fn.exists = function () {
    return this.length !== 0;
};

$(function () {
    $('img')
    .on('dragstart', function(event) { 
      event.preventDefault(); 
    })
    .on('contextmenu', function(e) {
      return false;
    });

    var myLazyLoad;
    myLazyLoad = null;
    myLazyLoad = new LazyLoad({
        unobserve_entered: true,
        elements_selector: ".lazy",
    });

    if ($(".section--video").exists()) {
        $(".section--video").each(function () {
            var $this = $(this);
            var videoElement = $this.find(".section--video__item")[0];
            var videoSrc = $this.find(".section--video__item").data("src");

            $this.addClass("tween");

            videoElement.src = videoSrc;
            videoElement.load();

            videoElement.addEventListener("canplay", function (e) {
                $this.addClass("is-playing");
                videoElement.play();
            });
            
            if ($this.find(".section--video__controls").length > 0) {
                var restart = $this.find(".section--video__controls .skip-start");
                var volume = $this.find(".section--video__controls .volume");
                var state = $this.find(".section--video__controls .state");
                var progress = $this.find(".section--video__controls .progress-bar");
                var progressVal = 0;

                // $('.play-video').on("click", function () {
                //     videoElement.play();
                //     state.removeClass("stop");

                //     volume.toggleClass("on");
                //     videoElement.muted = false;
                // });

                ScrollTrigger.create({
                    trigger: videoElement,
                    start: "top 90%",
                    end: "bottom 10%",
                    horizontal: false,
                    invalidateOnRefresh: true,
                    // markers: true,
                    onToggle: self => {
                        // console.log(self)
                        if (self.isActive) {
                            state.removeClass("stop");
                            videoElement.play();
                        } else {
                            state.addClass("stop");
                            videoElement.pause();
                        }
                    }
                });

                function progressLoop() {
                    setInterval(function () {
                        progressVal = (videoElement.currentTime / videoElement.duration) * 100;
                        progress.css("width", progressVal + "%");
                    });
                }

                progressLoop();

                restart.on("click", function () {
                    videoElement.currentTime = "0";
                    videoElement.pause();
                    videoElement.play();
                    state.removeClass("stop");
                });

                volume.on("click", function () {
                    $(this).toggleClass("on");
                    if ($(this).hasClass("on")) {
                        videoElement.muted = false;
                    } else {
                        videoElement.muted = true;
                    }
                });

                state.on("click", function () {
                    $(this).toggleClass("stop");
                    if ($(this).hasClass("stop")) {
                        videoElement.pause();
                    } else {
                        videoElement.play();
                    }
                });
            }
        });
    }

    if ($(".examples--slider").exists()) {
        const slider = document.querySelector(".examples--slider").querySelector(".slider");
        var sliderOptions = {
            autoPlay: 0,
            cellSelector: '.item',
            prevNextButtons: true,
            pageDots: false,
            lazyLoad: 2,
            arrowShape: 'M67,14.5v70.9L21.6,50L67,14.5z'
        };
        // groupCells at 768px
        if ( matchMedia('screen and (min-width: 1024px)').matches ) {
            sliderOptions.fade = true;
        }
        
        var sliderFlkty = new Flickity( slider, sliderOptions);
    }

    $('[data-scrollto]').on('click', function(){
        var el = $(this).data('scrollto');
        $("html,body").animate({
            scrollTop: $('#' + el).offset().top,
        }, 400);
    });
});